import React, {Fragment} from 'react';
import {FormattedMessage} from 'react-intl';
import {
  Form,
  Formik,
  Field,
  ErrorMessage
} from 'formik';
import {EmailField} from './EmailField';
import {ForgotPasswordSchema} from '../../../helpers/schemas';
import {Messages} from '../../layout/Messages/Messages';

function SendEmailForm(props) {
  const {request} = props;

  return (
    <Formik
      initialValues={{email: ""}}
      validationSchema={ForgotPasswordSchema}
      onSubmit={(values, {setSubmitting}) => {
        request(values.email)
        setSubmitting(false)
      }}
      validateOnChange={false}
    >
      {
        props => (
          <Fragment>
            <Messages
              color="danger"
              formikProps={props}
            >
              <ErrorMessage name="email" component="div"
                            data-testid="errors-email" className="field-error"/>
            </Messages>
            <Form>
              <EmailField handleBlur={props.handleBlur}/>

              <div className="text-center">
                <FormattedMessage id="app.forgot_password.submit_button">
                  {
                    valueBtn => <Field name="submit"
                                       className="my-4 btn btn-info"
                                       color="info" type="submit"
                                       value={valueBtn}/>
                  }
                </FormattedMessage>
              </div>
            </Form>
          </Fragment>
        )
      }
    </Formik>
  );
}

export {SendEmailForm};
